import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
        style: {
          // Smooth fade animation from center
          animation: 'fadeIn 0.2s ease-out',
        },
      }}
      style={{
        '--normal-bg': 'white',
        '--normal-text': '#1f2937',
        '--normal-border': '#e5e7eb',
      }}
      expand={false}
      {...props} />
  );
}

export { Toaster, toast }
